import { FunctionComponent, ReactNode } from 'react'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'
import styled, { css } from 'styled-components'
import { mobileAndTabletCSS } from '@measures/responsive'
import useShowBundling from '@hooks/useShowBundling'

interface RelatedItemsSidebarWrapperProps {
  children?: ReactNode
  accentColor?: string
}

const StyledRelatedItemsSidebarWrapper = styled.div<
  Pick<RelatedItemsSidebarWrapperProps, 'accentColor'>
>`
  ${({
    theme: {
      colors: { staticRed500 },
      spacing: { spacing16, spacing32 },
    },
    accentColor,
  }) => css`
    ${mobileAndTabletCSS(css`
      display: none;
    `)}

    display: grid;
    grid-row-gap: ${spacing16};
    align-items: flex-start;

    padding-top: ${spacing16};
    margin-left: -${spacing32};
    border-left: ${spacing32} solid ${accentColor ?? staticRed500};

    a {
      &:before {
        content: '';
        position: absolute;

        top: -${spacing16};
        left: 0;
        width: 118px;
        height: 16px;

        z-index: 1;
        background-color: ${accentColor ?? staticRed500};
      }
    }
  `}
`

const RelatedItemsSidebarWrapper: FunctionComponent<
  RelatedItemsSidebarWrapperProps
> = ({ children, accentColor }) => {
  const hasBundling = useIsInUltraModuleBundling()
  const shouldShowBundling = useShowBundling() && hasBundling

  if (!children) {
    return null
  }
  if (!shouldShowBundling) {
    return children
  }

  return (
    <StyledRelatedItemsSidebarWrapper accentColor={accentColor}>
      {children}
    </StyledRelatedItemsSidebarWrapper>
  )
}

export default RelatedItemsSidebarWrapper
